import {
  ProductSectionsCodeType,
  SectionCodesResponseDto,
} from '@tiendanube/common';
import {
  DeleteSectionsRequest,
  SectionsRequest,
  UpsertSectionsRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/SectionsRequest';

export const generateSectionsPayload = (
  originalSections: SectionCodesResponseDto,
  newSections: ProductSectionsCodeType[] | undefined,
): { sections: SectionsRequest[] } | undefined => {
  const sectionsToUpsert: UpsertSectionsRequest[] = [];
  const sectionsToDelete: DeleteSectionsRequest[] = [];

  if (!originalSections || !newSections) return undefined;

  originalSections.forEach((section) => {
    if (section === 'get-error' || section === 'update-error') return;

    if (!newSections.includes(section)) {
      sectionsToDelete.push({ id: section, '@delete': true });
    }
  });

  newSections.forEach((section) => {
    if (!originalSections.includes(section)) {
      sectionsToUpsert.push({ id: section });
    }
  });

  if (sectionsToUpsert.length === 0 && sectionsToDelete.length === 0)
    return undefined;

  return {
    sections: [...sectionsToUpsert, ...sectionsToDelete],
  };
};
